import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";
import { useOrganization } from "@/common/artemis-operations/organization";
import { FullSpin } from "@/components/base";

export const Route = createFileRoute("/_authenticated/$orgSlug")({
	component: OrgSlugLayout,
});

/**
 * Layout for the org-scoped app (`/<orgSlug>/workspaces/...`). The slug is a cosmetic/branding
 * prefix: the served organization always comes from the authenticated identity (never the URL), so
 * this only canonicalizes — if the path slug doesn't match the user's own org (a stale or shared
 * link), redirect to the correct slug.
 */
function OrgSlugLayout() {
	const { orgSlug } = Route.useParams();
	const { data: org, isPending } = useOrganization();
	const mySlug = org?.[0]?.slug;

	if (isPending) {
		return (
			<div style={{ height: "100vh" }}>
				<FullSpin />
			</div>
		);
	}
	if (mySlug && orgSlug !== mySlug) {
		return (
			<Navigate
				to="/$orgSlug/workspaces"
				params={{ orgSlug: mySlug }}
				replace
			/>
		);
	}
	return <Outlet />;
}
